import {
  CHANGE_BROWSER_NOTIFICATION,
  LOAD_NOTIFICATIONS
} from './actions'

export default function(state = {
  browserNotification: false,
  notifications: []
}, action) {
  switch(action.type) {
    case CHANGE_BROWSER_NOTIFICATION:
      return { ...state, browserNotification: action.payload }
    case LOAD_NOTIFICATIONS:
      return { ...state, notifications: action.payload }
    default:
      return state
  }
}
